import { AutogenModelCarrierPlanDetail, AutogenRowCarrierPlanDetail } from "./autogen/AutogenModelCarrierPlanDetail";

export class ModelCarrierPlanDetail extends AutogenModelCarrierPlanDetail<RowCarrierPlanDetail> {
	constructor() {
		super(RowCarrierPlanDetail);
	}
}

export class RowCarrierPlanDetail extends AutogenRowCarrierPlanDetail {
}